import React from "react";

const PrivacyPolicyTemplate = () => {
	return (
		<div
			style={{
				fontFamily: "'Helvetica Neue', Helvetica, Arial, sans-serif",
				padding: "1em",
			}}
		>
			<h1>
				<strong>Privacy Policy</strong>
			</h1>

			<p>
				This privacy policy applies to the Ramirez Soto Administración app
				(hereby referred to as "Application") for mobile devices that was
				created by Ramirez Soto (hereby referred to as "Service Provider") as a
				Free service. This service is intended for use "AS IS".
			</p>

			<h2>
				<strong>Information Collection and Use</strong>
			</h2>

			<p>
				The Application collects information when you download and use it. This
				information may include information such as:
			</p>
			<ul>
				<li>Your device's Internet Protocol address (e.g. IP address)</li>
				<li>
					The pages of the Application that you visit, the time and date of your
					visit, the time spent on those pages
				</li>
				<li>The time spent on the Application</li>
				<li>The operating system you use on your mobile device</li>
			</ul>

			<p>
				The Application does not gather precise information about the location
				of your mobile device.
			</p>

			{/* Hidden or optional content can be conditionally rendered */}
			{/* 
      <div style={{ display: 'none' }}>
        <p>The Application collects your device's location ...</p>
        ...
      </div>
      */}

			<p>
				The Service Provider may use the information you provided to contact you
				from time to time to provide you with important information, required
				notices and marketing promotions.
			</p>

			<p>
				For a better experience, while using the Application, the Service
				Provider may require you to provide us with certain personally
				identifiable information. The information that the Service Provider
				requests will be retained by them and used as described in this privacy
				policy.
			</p>

			<h2>
				<strong>Third Party Access</strong>
			</h2>

			<p>
				Only aggregated, anonymized data is periodically transmitted to external
				services to aid the Service Provider in improving the Application and
				their service. The Service Provider may share your information with
				third parties in the ways that are described in this privacy statement.
			</p>

			<p>
				Please note that the Application utilizes third-party services that have
				their own Privacy Policy about handling data. Below are the links:
			</p>
			<ul>
				<li>
					<a
						href="https://www.google.com/policies/privacy/"
						target="_blank"
						rel="noopener noreferrer"
					>
						Google Play Services
					</a>
				</li>
				<li>
					<a
						href="https://expo.io/privacy"
						target="_blank"
						rel="noopener noreferrer"
					>
						Expo
					</a>
				</li>
			</ul>

			<p>
				The Service Provider may disclose User Provided and Automatically
				Collected Information:
			</p>
			<ul>
				<li>
					As required by law, such as to comply with a subpoena, or similar
					legal process
				</li>
				<li>
					When they believe in good faith that disclosure is necessary to
					protect their rights, protect your safety or the safety of others,
					investigate fraud, or respond to a government request
				</li>
				<li>
					With their trusted service providers who work on their behalf and
					agree to adhere to this privacy policy
				</li>
			</ul>

			<h2>
				<strong>Opt-Out Rights</strong>
			</h2>

			<p>
				You can stop all collection of information by the Application easily by
				uninstalling it.
			</p>

			<h2>
				<strong>Data Retention Policy</strong>
			</h2>

			<p>
				The Service Provider will retain User Provided data for as long as you
				use the Application and for a reasonable time thereafter. To delete your
				data, contact:{" "}
				<a href="mailto:iandegyvesrs.sist@gmail.com">
					iandegyvesrs.sist@gmail.com
				</a>
			</p>

			<h2>
				<strong>Children</strong>
			</h2>

			<p>
				The Application does not address anyone under the age of 13. The Service
				Provider does not knowingly collect personally identifiable information
				from children under 13 years of age. If you are a parent or guardian and
				are aware your child has provided personal information, please contact
				the Service Provider to take necessary actions.
			</p>

			<h2>
				<strong>Security</strong>
			</h2>

			<p>
				The Service Provider provides physical, electronic, and procedural
				safeguards to protect information.
			</p>

			<h2>
				<strong>Changes</strong>
			</h2>

			<p>
				This Privacy Policy may be updated from time to time. You are advised to
				consult this page regularly for any changes.
			</p>

			<p>
				<strong>Effective date:</strong> 2025-06-13
			</p>

			<h2>
				<strong>Your Consent</strong>
			</h2>

			<p>
				By using the Application, you consent to the processing of your
				information as described in this policy.
			</p>

			<h2>
				<strong>Contact Us</strong>
			</h2>

			<p>
				If you have any questions regarding privacy while using the Application,
				please contact:
				<a href="mailto:iandegyvesrs.sist@gmail.com">
					{" "}
					iandegyvesrs.sist@gmail.com
				</a>
			</p>

			<hr />
			<p>
				This privacy policy page was generated by{" "}
				<a
					href="https://app-privacy-policy-generator.nisrulz.com/"
					target="_blank"
					rel="noopener noreferrer"
				>
					App Privacy Policy Generator
				</a>
			</p>
		</div>
	);
};

export default PrivacyPolicyTemplate;
